import type React from 'react';

import { DepartmentExtendedListItem } from '@vlabs/monokit/entities/departments/department-extended-list-item';
import { AttachUserDepartmentsButton, DetachUserDepartmentsIconButton } from '@vlabs/monokit/features/point';
import { useGetUser, useGetDepartments } from '@vlabs/api/artemy/client';
import type { UserId } from '@vlabs/api/artemy/model';
import { FoldableEntity } from '@vlabs/monokit/shared/ui/foldable-entity';

import { useUserDepartmentListTranslation } from './i18n';

interface UserDepartmentsProps {
  userId: UserId;
}

function UserDepartmentList({
  userId,
  ...props
}: UserDepartmentsProps): React.JSX.Element {
  const { t } = useUserDepartmentListTranslation();
  const { data: user } = useGetUser(userId);

  const { data: departments } = useGetDepartments({ department_ids: user?.department_ids }, {
    query: {
      enabled: (user?.department_ids?.length ?? 0) > 0,
    },
  });

  return (
    <FoldableEntity
      actions={<AttachUserDepartmentsButton userId={userId} />}
      heading={t('title')}
      {...props}
    >
      {departments?.departments?.map((department) => (
        <DepartmentExtendedListItem
          actions={(
            <DetachUserDepartmentsIconButton
              departmentIds={user?.department_ids ?? []}
              userId={userId}
            />
          )}
          departmentId={department.department_id}
          key={department.department_id}
        />
      ))}
    </FoldableEntity>
  );
}

export { UserDepartmentList };
